export default {
  electric_vehicle_code: 'EL',
  includes_animals_codes: [
    "DY",
    "HU",
    "KA",
    "FH"
  ],
  large_cab_codes: [
    'S5',
    'S6',
    'S7',
    'S8',
    'SV'
  ],
  includes_bikes_codes: [
    '2C',
    '1C',
    '3C'
  ],
  flex_driving_codes: [
    'GS', 'GT', 'HB', 'IL', 'HJ', 'ER', 'HØ', 'IV', 'KB', 'KG', 'NF', 'RK', 'SG', 'SI', 'SØ', 'VI', 'VO', 'VR', 'ÅB', 'ÅR', 'MO', 'TI', 'FA', 'SK', 'BI', 'AA', 'DJ', 'SA', 'OD', 'HE', 'KL', 'HH', 'GR', 'HS', 'ST', 'JU', 'SH', 'KO', 'FB', 'AK', 'RU'
  ],
  courier_service_code: 'BU',
  station_car_code: 'SC',
  discount_percentage_codes: [
    ['R8', 8],
    ['R4', 4],
    ['10', 10],
    ['R5', 5],
    ['11', 11],
    ['12', 12],
    ['15', 15],
    ['R6', 6],
    ['20', 20],
    ['35', 35],
    ['LR', 10],
    ['41', 41],
    ['42', 42],
  ],
  special_agreement_codes: [
    ['FC', 12],
    ['F1', 1],
    ['F2', 2],
    ['F3', 3],
    ['F4', 4],
    ['F5', 5],
    ['F8', 8],
    ['FX', 10],
    ['FZ', 15],
    ['FK', 20],
    ['FR', 25],
    ['FM,', 22],
    ['FS', 38],
    ['FY', 39],
  ],
  pickup_list_code: 'PU',
  eurobonus_code: 'EB'
}

export function getAttributeValue(attributes, codes) {
  const index = codes.findIndex(code => attributes.some(attribute => attribute.code === code[0]))
  return index !== -1 ? codes[index][1] : 'unknown'
}